/**
 * Directive for setting up a download button.
 *
 * Parameters:
 * @param label              label for the button
 * @param action             function which will be called after file is downloaded, use "true" for noop-action. otherwise route will be reloaded
 * @param entryPointParam    sets the extended entry point url
 * @param contentType        sets the content type
 * @param printToken         the token to get the parameters from
 * @param printTokenFunction the function to get the print token from
 */
angular.module('impactx.downloadbutton').directive('ixDownloadButton', function() {
    return {
        scope: {
            label: "=",
            action: "=",
            entryPointParam: "@",
            contentType: "@",
            printToken: "@",
            printTokenFunction: "="
        },
        restrict: 'E',
        templateUrl: 'shared/downloadbutton/templates/downloadbutton.tmpl.html',
        transclude: true,
        controller: 'DownloadButtonCtrl',
        controllerAs: 'ctrl'
    };
});